module.exports = __webpack_public_path__ + "img/activeaccountsetting.bfd6bbeb.svg";